export const paths = {
  version: `${process.env.PUBLIC_URL}/version.json`,
};
